<div class="lms-carousel">
    <div class="lms-carousel-header noselect" [style.height.px]='childElementHeight' (dblclick)="dblClickEvent($event)"
      (click)="openTerminalPopup()">
      <label class="lms-carousel-header-label">
        <ng-container *ngIf="label !== 'NET ALLOCATION'">
          {{label}}<span *ngIf="(label === 'DUE OUT SHOP')"> ({{terminalSummary?.numberShopped}})</span>
        </ng-container>
        <ng-container *ngIf="label === 'NET ALLOCATION'">
            <div class="net-alloc-div">
              <span class="angel-down"  (click)="showOverlay($event, op, yardLocalStationSummary);"></span>
              <div class="staion-overlay-box">

                <div class="net-alloc-text">
                  <p style="text-transform: uppercase;">{{configData && configData.yardLocalLabel.netAlloc}}: {{yardLocalStationSummary?.netAlloc}}</p>
                  <p>Avail vs. Plan: {{yardLocalStationSummary?.availVsPlan}}</p>
                </div>

              </div>
              <p-overlayPanel #op [dismissable]="true" [showCloseIcon]="true" styleClass="staion-overlay terminal-ribbon-overlay yardLocal-ribbon-overlay">
                <h2 [ngClass]="yardLocalStationSummary.inCompliance && yardLocalStationSummary.inCompliance.trim().toLowerCase()">
                  {{yardLocalStationSummary.allocStation}}</h2>
                <ul>

                  <li> <span class="pull-left">{{configData && configData.yardLocalLabel.plan}}</span> <span
                      class="pull-right">{{yardLocalStationSummary?.plan}}</span></li>

                  <li> <span class="pull-left">{{configData && configData.yardLocalLabel.allocated}}</span> <span
                      class="pull-right">{{yardLocalStationSummary?.alloc}}</span></li>

                  <li> <span class="pull-left">{{configData && configData.yardLocalLabel.shoppedStoredOOS}}</span> <span
                      class="pull-right"> {{yardLocalStationSummary?.shopStoreOOS}}</span></li>

                  <li> <span class="pull-left">{{configData && configData.yardLocalLabel.outsideGeofence}}</span> <span
                      class="pull-right"> {{yardLocalStationSummary?.outGeo}}</span></li>

                  <li class="net-allocation">
                    <span class="pull-left">{{configData && configData.yardLocalLabel.netAllocated}}</span> <span
                      class="pull-right"> {{yardLocalStationSummary?.netAllocValue}}</span>
                    <div class="clearfix"></div>
                    <div class="plan-percent-row">
                      <span class="pull-left plan-percent">{{configData && configData.yardLocalLabel.planPercent}}</span>
                      <span class="pull-right plan-percent">{{yardLocalStationSummary?.netAllocPercentX}}</span>
                    </div>
                  </li>

                  <li> <span class="pull-left">{{configData && configData.yardLocalLabel.otherYLUnit}}</span> <span
                      class="pull-right">{{yardLocalStationSummary?.otherYL}}</span></li>

                  <li> <span class="pull-left">{{configData && configData.yardLocalLabel.roadUnits}}</span> <span
                      class="pull-right">{{yardLocalStationSummary?.road}}</span></li>

                  <li class="net-allocation"> <span
                      class="pull-left">{{configData && configData.yardLocalLabel.availableVsPlan}}</span> <span
                      class="pull-right">{{yardLocalStationSummary?.availVsPlan}}</span></li>
                </ul>
              </p-overlayPanel>
            </div>
              <!-- <lms-yard-local-container-data  (onLocoSelect)='showLocoContextMenu($event);'  (locoOrStationSelectionEvent)='onLocoClick($event)' [stationDetailArr]='[status]'></lms-yard-local-container-data> -->
          </ng-container>
      </label>
      <span>
      {{value && value.length > 0 ? startIndex + 1 : 0}} - {{isPartialItemAvailable && (endIndex - startIndex) === getNumberOfItemVisible ? endIndex - 1
      : endIndex}} of {{value.length}}
      </span>
    </div>
    <div class="lms-carousel-data {{childElementHeight && childElementHeight === 75 ? 'dueOutStorageCls' : ''}}" [style.width]="dataWidth +'px'"
      [style.height.px]='childElementHeight'>
      <ul [style.width]="((getNumberOfItemVisible + 1) * childElementWidth) +'px'">
        <li *ngFor="let singleStatus of displayedItems">
          <ng-container>
            <div class="trainLocos" [style.width.px]="childElementWidth"
              [ngClass]="{'inPending':singleStatus?.inPendingList,'selectedDraged':(singleStatus?.clicked && !singleStatus?.inPendingList),'locate-highlight':singleStatus?.isLocated}"
              (click)="locoClickEvent(singleStatus, $event)" (mouseenter)="startLocoTooltip(singleStatus)"
                  (mouseleave)="hideLocoTooltip(singleStatus)"
              [attr.draggable]="!singleStatus?.inPendingList && singleStatus?.locomotiveIdentifier?.toLowerCase() !=='zzzzzzzzzzzzzz' && !checkForblankLocoIdentifier(singleStatus)"
              id='loco{{singleStatus?.locomotiveIdentifier}}' [attr.locoMixId]='singleStatus?.trainLocoMixId' [attr.Identifier]="singleStatus?.locomotiveIdentifier"
              [attr.index]="singleStatus?.index" (contextmenu)='$event.preventDefault(); showLocomotiveContextMenu(singleStatus);'>
              <lms-loco-svg [tab]="tab" [isDueOutShopScreen]="label === 'DUE OUT SHOP' ? true : false"
                [isStorageScreen]="label === 'STORED' ? true : false" [loco]="singleStatus" [isTerminalStatusSection]='true'
                [svgWidthClass]="'carousel-svg'"></lms-loco-svg>
                  <div class="panel-right" id="contextPanelID2"
                    *ngIf="singleStatus?.showTooltip && ((singleStatus.locomotiveIdentifier.toLowerCase() !=='zzzzzzzzzzzzzz') && !singleStatus?.inPendingList)">
                    <div class="loco-textPanel">
                      <span class="loco-id" *ngIf="singleStatus">{{formatLocomotiveId(singleStatus.locomotiveIdentifier)}}</span>
                      <span class="loco-class">{{singleStatus && singleStatus.clazz ? singleStatus.clazz : '-'}} </span>
                    </div>
                    <div class="loco-infoPanel">
                      <ul>
                        <li>
                          <span class="loco-label">
                            Dead Date
                          </span>
                          <span class="loco-value">
                            {{singleStatus && singleStatus.deadDate ? formatDateOnly(singleStatus.deadDate) : '-'}}
                          </span>
                        </li>
                        <li>
                          <span class="loco-label">
                            {{getDescription(singleStatus)}}
                          </span>
                          <span class="loco-value">
                          </span>
                        </li>

                      </ul>
                    </div>
                  </div>
            </div>
          </ng-container>
        </li>
      </ul>
    </div>
    <div class="lms-carosel-navigation noselect" [style.height.px]='childElementHeight'>
      <span class="fa fa-arrow-circle-left" (click)="onPrevNav()" [ngClass]="{'lms-carosel-navigation-disabled':(startIndex <= 0)}"></span>
      <span class="fa fa-arrow-circle-right" (click)="onNextNav()" [ngClass]="{'lms-carosel-navigation-disabled':(value && startIndex >= (value.length - 1))}"></span>
    </div>
  </div>
